import React, { useState, useCallback, useEffect } from 'react';
import Conexao from '../Config/conexao';
import axios from 'axios';
import Menu from '../Components/Navbar/navbar';
import { useDropzone } from 'react-dropzone'
import './CadastroLogin.css';
import { Container, Col, Row, Table, Button, Modal, Spinner } from 'react-bootstrap';
import { BeatLoader, BarLoader } from 'react-spinners';
import { Trash } from 'react-bootstrap-icons';
export default function CadastroLogin() {
    const [showPassword, setShowPassword] = useState(false);
    const [showContPassword, setShowContPassword] = useState(false);
    const [file, setFile] = useState(null);
    const [fileBase64String, setFileBase64String] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [username, setUsername] = useState('');
    const [cargo, setCargo] = useState('');
    const [setor, setSetor] = useState('');
    const [pais, setPais] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showModalTrash, setShowModalTrash] = useState(false);
    const [array, setArray] = useState([]);
    const [zoomedImageIndex, setZoomedImageIndex] = useState(null);
    const [isLoading, setIsLoading] = useState();
    const [selectedId, setSelectedId] = useState(0)
    const [name, setName] = useState("");
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = array.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(array.length / itemsPerPage);
    const handleSubmit = (event) => {
        event.preventDefault();
        // Verificar se todos os campos foram preenchidos
        if (!firstName || !lastName || !username || !cargo || !setor || !pais || !password || !confirmPassword) {
            alert('Por favor, preencha todos os campos.');
            return;
        } else {
            if (password.length >= 6) {
                if (password !== confirmPassword) {
                    setErrorMessage('As senhas não são iguais');
                } else {
                    setErrorMessage('');
                    onFileChange()

                }
            } else {
                setErrorMessage('A senha tem que ter mais de 6 caracteris');
            }
        };
    }

    useEffect(() => {
        ListarLogin();
    }, [])



    async function SalvarCadastro(base64String) {

        const name = firstName + "" + lastName
        const obj = {
            name, username, cargo, setor, pais, password, fileBase64String: base64String
        };

        const res = await axios.post(Conexao.api + 'SalvarLogin.php', obj);

        console.log('SalvarLista', obj)

        if (res.data.success === true) {
            alert('Login Salvo com Sucesso!')
            setShowModal(false)
        }
        ListarLogin();

    };
    async function ListarLogin() {
        try {
            setIsLoading(true);
            const res = await axios.get(Conexao.api + 'ListaLogin.php');
            console.log(res.data.result);
            setArray(res.data.result);
            setIsLoading(false);

        } catch (error) {
            console.error(error);
        }

    }

    async function ExcluirLogin() {

        const obj = {

        };
        const res = await axios.get(Conexao.api + 'ExcluirLogin.php?id=' + selectedId);
        console.log(Conexao.api + 'ExcluirLogin.php', obj)
        if (res.data.success === true) {
            setShowModalTrash(false)
            alert('Login Excluido com Sucesso!')

        }
        ListarLogin();
    }

    async function onFileChange() {
        const reader = new FileReader();

        reader.onloadend = () => {
            // Remove o prefixo "data:..." da string base64
            const base64String = reader.result.replace(/^data:.+;base64,/, '');
            setFileBase64String(base64String);
            console.log('fileBase64String', base64String);
            SalvarCadastro(base64String)
        };

        if (file) {
            reader.readAsDataURL(file);
        }
    };


    const onDrop = useCallback(acceptedFiles => {
        setFile(acceptedFiles[0]);
        console.log(acceptedFiles)
    }, [])
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })
    if (isLoading) {
        return (
            <body class="bg-light">
                <div>
                    <Menu />
                    <Container style={{ marginTop: '100px' }}>
                        <h2 style={{ textAlign: 'center', marginTop: '60px', color: '#3EBF52' }}>Lista de Logins</h2>



                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '20vh', marginTop: '0%' }}>
                            <span style={{ color: "#000000", fontSize: '20px' }}>Loading...</span>
                            <BeatLoader color="#FFD700" />



                        </div>




                    </Container>

                </div>
            </body>
        );
    }

    return (<body class="bg-light">
        <div>
            <Menu />
            <Container style={{ marginTop: '100px' }}>

                <h2 style={{ textAlign: 'center', marginTop: '60px', color: '#3EBF52' }}>Lista de Logins</h2>
                <button class="btnlogin" onClick={() => setShowModal(true)} style={{ float: 'right', padding: '10px 20px' }}>Cadastrar Login</button>
                <Row style={{ marginTop: '10%' }}>

                    <Col>
                        <Table >
                            <thead striped bordered hover style={{ backgroundColor: '#3EBF52' }}>
                                <tr>
                                    <th style={{ fontSize: '20px', textAlign: 'center' }}>Nome</th>
                                    <th style={{ fontSize: '20px', textAlign: 'center' }}>Usuario</th>
                                    <th style={{ fontSize: '20px', textAlign: 'center' }}>Setor</th>
                                    <th style={{ fontSize: '20px', textAlign: 'center' }}>Nivel</th>
                                    <th style={{ fontSize: '20px', textAlign: 'center' }}>Assinatura</th>
                                    <th style={{ fontSize: '20px', textAlign: 'center' }}>Visualizar</th>
                                </tr>
                            </thead>
                            <tbody >
                                {currentItems.map((item, index) => (
                                    <tr key={index}>
                                        <td style={{ fontSize: '15px', textalign: 'center', verticalAlign: 'center', }}>{item.nome}</td>
                                        <td style={{ fontSize: '15px', textAlign: 'center' }}>{item.usuario}</td>
                                        <td style={{ fontSize: '15px', textAlign: 'center' }}>{item.setor}</td>
                                        <td style={{ fontSize: '15px', textAlign: 'center' }}>{item.nivel}</td>
                                        <td style={{ fontSize: '15px', textAlign: 'center' }}>
                                            <img
                                                src={`data:image/jpeg;base64,${item.assinatura}`}
                                                alt="Assinatura"
                                                style={{
                                                    width: zoomedImageIndex === index ? '500px' : '300px',
                                                    height: zoomedImageIndex === index ? '250px' : '150px',
                                                    transition: 'all 0.5s ease',
                                                    objectFit: 'cover',
                                                    transform: zoomedImageIndex === index ? 'scale(1)' : 'scale(0.2)'
                                                }}
                                                onClick={() => setZoomedImageIndex(zoomedImageIndex === index ? null : index)}
                                            />
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            <Button variant="danger" style={{ marginLeft: 'auto', marginRight: 'auto' }} onClick={() => {
                                                setSelectedId(item.id);
                                                setName(item.nome)
                                                setShowModalTrash(true);
                                            }}>
                                                <Trash />
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>


                        </Table>
                        <nav aria-label="Navegação de página exemplo">
                            <ul class="pagination">
                                <li className="page-item">
                                    <a
                                        className="page-link"
                                        href="#"
                                        aria-label="Anterior"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
                                        }}
                                    >
                                        <span aria-hidden="true">&laquo;</span>
                                        <span className="sr-only">Anterior</span>
                                    </a>
                                </li>
                                {Array(Math.ceil(array.length / itemsPerPage)).fill().map((_, index) => (
                                    <li className="page-item">
                                        <a
                                            className="page-link"
                                            key={index}
                                            onClick={() => setCurrentPage(index + 1)}
                                            style={{
                                                cursor: 'pointer',
                                                backgroundColor: currentPage === index + 1 ? 'blue' : 'white'
                                            }}
                                        >
                                            {index + 1}
                                        </a>
                                    </li>
                                ))}
                                <li className="page-item">
                                    <a
                                        className="page-link"
                                        href="#"
                                        aria-label="Próximo"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setCurrentPage(prevPage => prevPage + 1);
                                        }}
                                        style={{ visibility: currentPage === totalPages ? 'hidden' : 'visible' }}
                                    >
                                        <span aria-hidden="true">&raquo;</span>
                                        <span className="sr-only">Próximo</span>
                                    </a>
                                </li>
                                <li className="page-item">
                                    <select
                                        className="page-link"
                                        value={itemsPerPage}
                                        onChange={(e) => setItemsPerPage(Number(e.target.value))}
                                        style={{ visibility: currentPage === totalPages && currentPage !== 1 ? 'hidden' : 'visible' }}
                                    >
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={20}>20</option>
                                        <option value={30}>30</option>
                                        <option value={40}>40</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </select>
                                </li>
                            </ul>

                        </nav>
                    </Col>

                </Row>
            </Container>

            <div style={{ width: '100%', marginTop: '10%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '10%' }}>
                <Modal show={showModalTrash} onHide={() => setShowModalTrash(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirmação de Exclusão</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <BarLoader color="#FFD700" />
                        <p style={{ marginLeft: '10px' }}>Tem certeza de que deseja excluir {name} ?</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModalTrash(false)}>
                            Cancelar
                        </Button>
                        <Button variant="danger" onClick={() => ExcluirLogin()} >
                            Excluir
                        </Button>
                    </Modal.Footer>
                </Modal>


                <Modal show={showModal} onHide={() => setShowModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Cadastro de Login</Modal.Title>
                    </Modal.Header>

                    <Modal.Body style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>


                        <div class="col-md-10 col-lg-10">


                            <div class="row g-3">
                                <div class="col-sm-6">
                                    <label for="firstName" class="form-label">First name</label>
                                    <input type="text" class="form-control" id="firstName" placeholder="" value={firstName} onChange={e => setFirstName(e.target.value)} required />
                                    <div class="invalid-feedback">
                                        Primeiro Nome.
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <label for="lastName" class="form-label">Last name</label>
                                    <input type="text" class="form-control" id="lastName" placeholder="" value={lastName} onChange={e => setLastName(e.target.value)} required />
                                    <div class="invalid-feedback">
                                        Segundo Nome.
                                    </div>
                                </div>
                                <div class="col-12">
                                    <label for="username" class="form-label">Login</label>''
                                    <div class="input-group has-validation">
                                        <span class="input-group-text">*</span>
                                        <input type="text" class="form-control" id="username" placeholder="Login" value={username} onChange={e => setUsername(e.target.value)} required />
                                        <div class="invalid-feedback">
                                            Your username is required.
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <label for="username" class="form-label">Cargo</label>
                                    <select class="form-select" id="country" style={{ cursor: 'pointer' }} value={cargo} onChange={e => setCargo(e.target.value)} required>
                                        <option value="">Selecione...</option>
                                        <option>Gerente</option>
                                        <option>Supervisor</option>
                                        <option>Operador</option>
                                    </select>
                                    <div class="invalid-feedback">
                                        Selecione um cargo valido.
                                    </div>
                                </div>
                                <div class="col-12">
                                    <label for="username" class="form-label">Setor</label>
                                    <select class="form-select" id="country" style={{ cursor: 'pointer' }} value={setor} onChange={e => setSetor(e.target.value)} required>
                                        <option value="">Selecione...</option>
                                        <option>Laboratorio</option>
                                        <option>SGI</option>
                                        <option>QSSMA</option>
                                        <option>RH</option>
                                        <option>Compras</option>
                                        <option>Almoxarifado</option>
                                    </select>
                                    <div class="invalid-feedback">
                                        Selecione um setor valido.
                                    </div>
                                </div>
                                <div class="col-12">
                                    <label for="username" class="form-label" >País</label>
                                    <select class="form-select" id="country" style={{ cursor: 'pointer' }} value={pais} onChange={e => setPais(e.target.value)} required>
                                        <option value="">Selecione...</option>
                                        <option>Brasil</option>
                                        <option>Portugal</option>
                                        <option>Moçabique</option>
                                    </select>
                                    <div class="invalid-feedback">
                                        Selecione um País valido.
                                    </div>
                                </div>

                                <div className="col-12">
                                    <label htmlFor="password" className="form-label">Senha</label>
                                    <div className="input-group has-validation">
                                        <input
                                            type={showPassword ? 'text' : 'password'}
                                            className="form-control"
                                            id="password"
                                            placeholder="Password"
                                            value={password}
                                            onChange={e => setPassword(e.target.value)}
                                            required
                                        />
                                        <div className="input-group-append">
                                            <button
                                                type="button"
                                                className="btn btn-outline-secondary"
                                                onClick={() => setShowPassword(!showPassword)}
                                            >
                                                {showPassword ? 'Hide' : 'Show'}
                                            </button>
                                        </div>
                                        <div className="invalid-feedback">
                                            Your password is required.
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <label htmlFor="confirmPassword" className="form-label">Confirmar Senha</label>
                                    <div className="input-group has-validation">
                                        <input
                                            type={showConfirmPassword ? 'text' : 'password'}
                                            className="form-control"
                                            id="confirmPassword"
                                            placeholder="Password"
                                            value={confirmPassword}
                                            onChange={e => setConfirmPassword(e.target.value)}
                                            required
                                        />
                                        <div className="input-group-append">
                                            <button
                                                type="button"
                                                className="btn btn-outline-secondary"
                                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                            >
                                                {showConfirmPassword ? 'Hide' : 'Show'}
                                            </button>
                                        </div>
                                        <div className="invalid-feedback">
                                            Your password is required.
                                        </div>
                                    </div>
                                </div>
                                {errorMessage && <p>{errorMessage}</p>}


                            </div>
                            <hr class="my-4"></hr>
                            <label for="username" class="form-label">Assinatura</label>
                            <div {...getRootProps()} style={{ cursor: 'pointer', border: '2px dashed #000', padding: '20px', borderRadius: '10px' }}>
                                <input {...getInputProps()} />

                                {
                                    isDragActive ?
                                        <p>Solte o arquivo aqui...</p> :
                                        !file ?
                                            <p>Arraste e solte arquivo aqui ou clique para selecione o arquivo</p> :
                                            <p>Arquivo carregado: {file.name}</p>
                                }
                            </div>

                            <hr class="my-4"></hr>
                            <button class="w-100 btn btn-primary btn-lg" type="submit" onClick={(e) => handleSubmit(e)}>Salvar</button>

                        </div>



                    </Modal.Body>
                </Modal>
            </div>


        </div>
    </body >
    );
}

